import BackendDeveloperPage from "./BackendDeveloperPage";

export default function DotNetDeveloperPage() {
  return <BackendDeveloperPage technology="dotnet" />;
}
